import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { uiStore } from 'shared/store/uiStore'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SettingsRoutes } from 'pages/settings/route/type'

export const AddSubscriptionAccessLayout = observer(() => {
  const { subscriptionStore, userPermissionsStore } = useEntitiesContext()

  const [loading, setLoading] = useState<boolean | null>(true)

  useEffect(() => {
    Promise.all([subscriptionStore.initPromise, userPermissionsStore.initPromise]).then(() => {
      const can_manage_billing_settings = userPermissionsStore.getItem(
        'can_manage_billing_settings'
      )

      if (!can_manage_billing_settings || !subscriptionStore.isCanceled) {
        uiStore.changeRoute({
          path: `/${SettingsRoutes.root}`,
        })
        return
      }

      setLoading(false)
    })
  }, [])

  if (loading) return <SpinnerLoader ariaLabel={'AccessLayout'} />
  return <Outlet />
})
